import React from 'react';
import ButtonAction from '../../../../common/components/ui/ButtonAction';
import {useReceiptsGridContext} from '../ReceiptsGridContext';
import download from '../../../../common/assets/icons/download.svg';
import styles from './ButtonDownload.module.scss';

const ButtonDownload = ({}) => {
  const {saveListToExcelFile} = useReceiptsGridContext();

  return (
    <ButtonAction
      variant={'icon'}
      icon={download}
      onClick={saveListToExcelFile}
      customClassnames={{
        container: styles.buttonContainer,
        icon: styles.buttonIcon,
      }}
    />
  );
};

export default ButtonDownload;
